<template>
  <div class="row align-items-center my-5">
    <div v-for="(model, index) in arrayModels" class="mt-2 col-lg-3 col-6" :key="model.id">
      <div class="card-pagination my-4">
        <div class="bloco-w d-flex flex-column align-items-center justify-content-center">
          <img :class="styleClassImg(index)" 
            :src="`${model.cover}`" 
            :alt="model.title" 
            @click="$emit('showModalEcard', true, model, styleClassW(index))"
            width="241" height="365">
        </div>
        <div class="card-body d-flex flex-column align-items-center">
          <div :class="styleClassW(index)">
            <h5 class="card-title my-2">{{ model.title }}</h5>
            <div class="button--more" @click="$emit('showModalEcard', true, model, styleClassW(index))">

              {{ translate.shootModel }} <font-awesome-icon :icon="['fas', 'arrow-right']" size="sm"
                style="margin-left: 8px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr />
  <vue-awesome-paginate :total-items="paginations.total" v-model="currentPage" :items-per-page="paginations.per_page"
    :max-pages-shown="3" :on-click="onClickHandler" />
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import modelsTradutor from 'tradutors/ecards'
import api from '../../api'

export default defineComponent({
  name: 'AllEcardsPAgination',
  props: ['models'],
  emits: ['showModalEcard'],
  computed: {
    ...mapState(localeStore, ['locale']),
    translate: function () {
      if (this.locale === 'pt-br') {
        return modelsTradutor.portugues
      } else {
        return modelsTradutor.ingles
      }
    }
  },
  data() {
    return {
      currentPage: this.models.current_page,
      arrayModels: this.models.data,
      paginations: this.models
    }
  },
  methods: {
    onClickHandler(page: number) {
      this.currentPage = page
      this.getNewPage(page)
    },
    getNewPage(page) {
      api.get('v1/ecards/getAllEcards?page=' + page).then(({ data }) => {
        const { modelsArray } = data
        this.paginations = modelsArray
        this.arrayModels = modelsArray.data
      })
    },
    styleClassImg(index) {
      return 'cursor-pointer vertical-h vertical-w'
      // if (index < 4) return index % 2 == 0 ? 'vertical-h vertical-w' : 'horizontal-h horizontal-w'
      // return !(index % 2 == 0) ? 'vertical-h vertical-w' : 'horizontal-h horizontal-w'
    },
    styleClassW(index) {
      return 'vertical-w'
      // if (index < 4) return index % 2 == 0 ? 'vertical-w' : 'horizontal-w'
      // return !(index % 2 == 0) ? 'vertical-w' : 'horizontal-w'
    }
  }
})
</script>
<style scoped lang="css">
.button--more svg {
  color: #b20000;
}

.button--more {
  height: 19px;
  color: #5b5858;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  cursor: pointer;
}

.small svg {
  margin-right: 5px;
}

.card-title {
  height: 28px;
  color: #B20000;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.bloco-w {
  height: 365px;
}

.horizontal-h {
  height: 100%;
  max-height: 246px;
}

.vertical-h {
  height: 100%;
  max-height: 365px;
  object-fit: cover;
}

.horizontal-w {
  width: 100%;
  max-width: 335px;
}

.vertical-w {
  width: 100%;
  max-width: 241px;
  object-fit: cover;
}

hr {
  margin-top: 30px;
  border-bottom: solid 2px #ddd;
  margin-bottom: 30px;
}

.card-pagination {
  background-color: transparent;
}

.card-body {
  padding: 10px 0px;
}
/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .horizontal-h {
    width: 100%;
    height: unset;
  }

  .vertical-h {
    width: 100%;
    height: unset;
    object-fit: cover;
  }

  .horizontal-w {
    width: 100%;
    height: unset;
  }

  .vertical-w {
    width: 100%;
    height: unset;
    object-fit: cover;
  }

  .card-title {
    font-family: 'Exo-2';
    font-weight: 300;
    color: #898989;
    font-size: 16px;
  }

  .button--more {
    font-size: 12px;
  }

  .bloco-w {
    height: unset;
  }

}
</style>
